import { useCallback, useState } from "react";
import { useScoreApi, unwrap } from "../api/scoreApi";

// #3355 -- admin fallback to set an emergency manual ride's ring (score-api
// PUT /ride/:rideId/ring). The ring is copied from the class at create, but a
// class with no ring (or the wrong one) leaves the ride invisible to every
// ring-scoped view (announcer, scoreboard, scribe ring list).
export function useSetManualRideRing() {
  const scoreApi = useScoreApi();
  const [saving, setSaving] = useState(false);

  const setRing = useCallback(
    async (rideId, ring) => {
      setSaving(true);
      try {
        return unwrap(await scoreApi.rides.setManualRideRing(rideId, { ring }));
      } finally {
        setSaving(false);
      }
    },
    [scoreApi],
  );

  return { setRing, saving };
}

export default useSetManualRideRing;
